import {SpeakerWaveIcon, SpeakerXMarkIcon} from '@heroicons/react/16/solid';
import {useState} from 'react';
import {TEXT_INPUT_STYLE} from './styles';

interface VolumeSliderProps {
  initialVolume: number;
  setVolume: (volume: number) => void;
}
export function VolumeSlider({initialVolume, setVolume}: VolumeSliderProps) {
  const [channelVolumeSliderValue, setChannelVolumeSliderValue] = useState(initialVolume);
  const [channelVolumeInputValue, setChannelVolumeInputValue] = useState(String(Math.round(initialVolume * 100)));

  const handleChangeVolume = (volume: number) => {
    if (volume < 0) {
      volume = 0;
    }
    if (volume > 1) {
      volume = 1;
    }
    setVolume(volume);
    setChannelVolumeSliderValue(volume);
    setChannelVolumeInputValue(String(Math.round(volume * 100)));
  };

  return (
    <div className="flex flex-row">
      <button className="hidden mt-auto lg:inline" onClick={() => handleChangeVolume(0)}>
        <SpeakerXMarkIcon className="inline h-5" /> 0
      </button>
      <div className="w-full md:w-auto flex-col text-center mr-1 ml-1">
        <input
          className="text-center rounded-lg w-7 bg-blue-200"
          value={channelVolumeInputValue}
          onChange={event => setChannelVolumeInputValue(event.target.value)}
          onBlur={event => handleChangeVolume(parseInt(event.target.value) / 100)}
        />
        <br />
        <input
          className={`${TEXT_INPUT_STYLE} outline-none`}
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={channelVolumeSliderValue}
          onChange={event => handleChangeVolume(parseFloat(event.target.value))}
        />
      </div>
      <button className="hidden mt-auto lg:inline" onClick={() => handleChangeVolume(1)}>
        <SpeakerWaveIcon className="inline h-5" /> 100
      </button>
    </div>
  );
}
